import {TranslateService} from '@brunata-angular/util';
import {
    ColumnHeader,
    FilterFormGroup,
    SelectFormGroup,
} from './select-meters-for-variable-alarms.model';

export function getColumnHeads(
    filterForm: FilterFormGroup,
    translateService: TranslateService,
    selectedColumnsForm: SelectFormGroup,
): ColumnHeader[] {
    return [
        {
            label: translateService.translate('variable-alarms_selection'),
            column: 'select',
            formControl: filterForm.controls.select,
            formType: 'selectMultiple',
            displayControl: selectedColumnsForm.controls.select,
        },
        {
            label: translateService.translate('properties_meterNo', 'online', 'systems'),
            column: 'meterNo',
            formControl: filterForm.controls.meterNo,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.meterNo,
        },
        {
            label: translateService.translate('properties_printedMeterNumber', 'online', 'systems'),
            column: 'printedSerialNo',
            formControl: filterForm.controls.printedSerialNo,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.printedSerialNo,
        },
        {
            label: translateService.translate('properties_meterModel', 'online', 'systems'),
            column: 'meterModel',
            formControl: filterForm.controls.meterModel,
            formType: 'selectMultiple',
            displayControl: selectedColumnsForm.controls.meterModel,
        },
        {
            label: translateService.translate('properties_placement', 'online', 'systems'),
            column: 'placement',
            formControl: filterForm.controls.placement,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.placement,
        },
        {
            label: translateService.translate('monitoring_usageAndUnits'),
            column: 'usageAndUnit',
            formControl: filterForm.controls.usageAndUnit,
            formType: 'selectMultiple',
            displayControl: selectedColumnsForm.controls.usageAndUnit,
        },
        {
            label: translateService.translate('properties_mountingDate', 'online', 'common'),
            column: 'mountingDate',
            formControl: filterForm.controls.mountingDate,
            formType: 'date',
            displayControl: selectedColumnsForm.controls.mountingDate,
        },
        {
            label: translateService.translate('utilities_dismount-date'),
            column: 'dismountedDate',
            formControl: filterForm.controls.dismountedDate,
            formType: 'date',
            displayControl: selectedColumnsForm.controls.dismountedDate,
        },
        {
            label: translateService.translate('properties_address', 'online', 'systems'),
            column: 'address',
            formControl: filterForm.controls.address,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.address,
        },
        {
            label: translateService.translate('common_SECONDSECTORNO', 'online', 'common'),
            column: 'property',
            formControl: filterForm.controls.property,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.property,
        },
        {
            label: translateService.translate('common_FIRSTSECTORNO', 'online', 'common'),
            column: 'branch',
            formControl: filterForm.controls.branch,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.branch,
        },
        {
            label: translateService.translate('common_LOCATIONNO', 'online', 'common'),
            column: 'location',
            formControl: filterForm.controls.location,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.location,
        },
        {
            label: translateService.translate('titles_residents', 'online', 'systems'),
            column: 'currentResident',
            formControl: filterForm.controls.currentResident,
            formType: 'text',
            displayControl: selectedColumnsForm.controls.currentResident,
        },
    ];
}
